<template>
  <div class="page-content">
    <!-- <div class="top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/productControl/productRegistration' }">产品列表</el-breadcrumb-item>
        <el-breadcrumb-item>产品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="title-wrap">
      <div class="title" style="display: flex;justify-content: flex-start;">
        <span class="go-back el-icon-back" @click="goBack"></span>
        <span class="type">{{ deviceInfos.productName }}</span>
        <!-- <span class="device-num">设备数:{{deviceNum}}</span>
        <span class="go-layer" @click="toLayer">前往管理</span> -->
      </div>
      <div v-if="!proStatus">
        <el-button type="primary" @click="issue">发布</el-button>
      </div>
      <div v-else>
        <el-button  @click="unIssue">取消发布</el-button>
      </div>
    </div>
    <div class="nav">
        <el-row>
          <el-col :span="24">
             <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                :label="item.title"
                :name="item.name"
                v-for="item in tableOptions"
                :key="item.name"
                >
                <keep-alive>
                   <component :is='item.content' v-if="item.name === activeName" ref="productRef" @my-event="childClick" :status="status"></component>
                </keep-alive>
                </el-tab-pane>
              </el-tabs>
          </el-col>
        </el-row>
    </div>
    <el-dialog
       :close-on-click-modal="false"
      title="确认产品发布"
      :append-to-body="true"
      :visible.sync="dailogFlag"
      width="50%"
      >
      <div class="issue-title">
        <h1>您即将发布的产品为：{{deviceInfos.productName}}</h1>
        <p>产品发布后将从开发阶段进入到正式投产或使用阶段。</p>
      </div>
      <div class="hint">请勾选并确认该产品的信息和各项功能已具备发布条件：</div>
      <div class="confirm">
        <div class="confirm-item" v-for="(item,index) in issueList" :key="item.id" @click="chooseStep(index)">
          <div class="left">
            <p>
              <span class="step">第 {{index+1}} 步</span>
              <span class="step-info">{{item.stepMes}}</span>
            </p>
          </div>
          <div class="right">
            <span :class="item.test? 'span-active': ''">{{item.choose}}</span>
            <i :class="['el-icon-circle-check', item.test? 'i-active': '' ]" style="font-size:26px"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button :disabled="!allFlag" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from '@/assets/js/eventBus'
import ProductInfo from '../../components/product_control/productInfo' 
import FunctionDefinition from '../../components/product_control/functionDefinition'
import ProductDevices from '../../components/product_control/productDevices'
import InfoCommunication from '../../components/product_control/infoCommunication '
import DataAnalysis from '@/components/product_control/dataAnalysis'
import { issueProduct, unIssueProduct } from '@/api/productRegistration'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      deviceInfos: {}, // 设备信息
      activeName: '0',
      productDetailQueryType: '0',
      dailogFlag: false,
      // issueFlag: false,
      issueList: [
        {
          stepMes: '请确认产品的各项基本信息准确无误，产品发布后将无法再做修改和删除。',
          id: 0,
          test: false,
          choose: '请选择'
        },
        {
          stepMes: '请确认设备的各项功能已经完成开发和调试，发布后产品的功能改动请通过 OTA 升级。',
          id: 1,
          test: false,
          choose: '请选择'
        },
        {
          stepMes: '请确认产品已经具备上线发布条件，开始进入规模化接入和部署。',
          id: 2,
          test: false,
          choose: '请选择'
        }
      ],
      stepFlag0: '',
      stepFlag1: '',
      stepFlag2: '',
      // allFlag: true,
      deviceNum: '',
      status: ''
    }
  },
  created () {
    this.deviceNum = sessionStorage.getItem('deviceNum')
    // if (localStorage.getItem('infos')) {
    //   this.deviceInfos = JSON.parse(localStorage.getItem('infos'))
    // } else {
    localStorage.setItem('sRowInfo', this.$route.query.sRow);
    this.deviceInfos = JSON.parse(this.$route.query.sRow)
    // }
    this.getActiveName()
  },
  computed: {
    ...mapGetters(['proStatus']),
    tableOptions () {
      let list = []
      if (JSON.parse(this.$route.query.sRow).dataFormat === 1) {
        list = [
          {
            title: '产品信息',
            name: '0',
            content: ProductInfo
          },
          {
            title: '消息通信',
            name: '1',
            content: InfoCommunication
          },
          {
            title: '功能定义',
            name: '2',
            content: FunctionDefinition
          },
          {
            title: '数据解析',
            name: '3',
            content: DataAnalysis
          }
        ]
      } else {
        list = [
          {
            title: '产品信息',
            name: '0',
            content: ProductInfo
          },
          {
            title: '消息通信',
            name: '1',
            content: InfoCommunication
          },
          {
            title: '功能定义',
            name: '2',
            content: FunctionDefinition
          },
          {
            title: '设备数据',
            name: '3',
            content: ProductDevices
            // content: {
            //   deviceInfos: this.deviceInfos,
            //   deviceNum: this.deviceNum
            // }
          }
        ]
      }
      return list
    },
    allFlag () {
      const result = this.issueList.every((e) => {
        return e.test === true // 条件判断
      })
      console.log('issueList中的test', result)
      return result
    }
  },
  watch: {
    issueList: {
      immediate: true,
      handler (vla) {
        console.log(vla)
      }
    }
  },
  mounted () {
    eventBus.$on('productName', data => {
      this.deviceInfos.productName = data
    })
  },
  updated () {
    // console.log('产品名！！！！！！！', this.deviceInfos.productName)
  },
  methods: {
    childClick (childState, deviceNum) {
      this.deviceNum = deviceNum
      /* if (childState === '已发布') {
        this.issueFlag = true
      } else {
        this.issueFlag = false
      } */
    },
    getActiveName () {
      if (sessionStorage.getItem('productDetailQueryType')) {
        this.activeName = sessionStorage.getItem('productDetailQueryType')
      } else {
        this.activeName = '0'
      }
    },
    issue () {
      this.dailogFlag = true
    },
    unIssue () {
      this.$confirm(`确认要将${this.deviceInfos.productName}产品撤销发布吗？, 是否继续?`, '撤销产品', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const params = {
          empty: true,
          params: {
            productKey: this.deviceInfos.productKey
          }
        }
        unIssueProduct(params)
          .then(res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '撤销产品成功!'
              })
              // this.issueFlag = false
              this.status = '1'
              this.activeName = '0'
              sessionStorage.setItem('productDetailQueryType', '0')
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    cancle () {
      this.dailogFlag = false
    },
    confirm () {
      if (this.stepFlag0 === 1 && this.stepFlag1 === 1 && this.stepFlag2 === 1) {
        const params = {
          empty: true,
          params: {
            productKey: this.deviceInfos.productKey
          }
        }
        issueProduct(params)
          .then(
            res => {
              if (res.data.code === 200) {
                this.$message({
                  message: '发布成功',
                  type: 'success'
                })
                // this.issueFlag = true
                this.dailogFlag = false
                this.status = '2'
                this.activeName = '0'
                sessionStorage.setItem('productDetailQueryType', '0')
                // this.$refs.productRef[0].getProductInfos()
                // TODO: 触发子组件获取列表功能
              }
            }
          )
      }
    },
    chooseStep (val) {
      this.issueList[val].test = !this.issueList[val].test
      this.issueList[val].choose = this.issueList[val].test ? '已确认' : '请选择'
      this.stepFlag0 = this.issueList[0].test ? 1 : 0
      this.stepFlag1 = this.issueList[1].test ? 1 : 0
      this.stepFlag2 = this.issueList[2].test ? 1 : 0
    },
    handleClick (tab) {
      if (tab.name === '0') {
        this.productDetailQueryType = '0'
      } else if (tab.name === '1') {
        this.productDetailQueryType = '1'
      } else if (tab.name === '2') {
        this.productDetailQueryType = '2'
      } else if (tab.name === '3') {
        this.productDetailQueryType = '3'
      }
      sessionStorage.setItem('productDetailQueryType', this.productDetailQueryType)
    },
    // toLayer () {
    //   this.$router.push({
    //     path: '/deviceManagement/DeviceManager',
    //     query: {
    //       productKey: this.deviceInfos.productKey
    //     }
    //   })
    // },
    goBack () {
      // window.history.go(-1)
      this.$router.push(
        { path: '/productControl/productRegistration', query: { productKey: this.$route.query.productKey } }
      )
    }

  },
  beforeDestroy () {
    eventBus.$off('productName') // 移除事件监听者
  }
}

</script>

<style lang="less" scoped>
  .top{
    margin-bottom: 30px;
    padding-left: 10px;
    border-left: 5px solid skyblue;
    /deep/ .el-breadcrumb__item{
      font-size: 16px;
    }
  }
  .title-wrap{
    display: flex;
    margin-bottom: 20px;
    box-sizing: border-box;
    justify-content: space-between;
    .title{
      width: 30%;
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      font-weight: 900;
      font-size: 16px;
      padding: 10px 10px 0 15px;
      border-bottom: 1px solid #C0C0C0;
      .go-back{
        cursor: pointer;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        width: 25px;
        color: black;
      }
      .type, .device-num{
        color: black;
      }
      .go-layer{
        color: skyblue;
      }
      .go-layer:hover{
        cursor: pointer;
      }
    }
  }
  .nav{
    /deep/ .el-tabs__nav-wrap::after{
      background: white;
    }
    /deep/ .el-tab-pane{
      font-size: 16px;
      overflow-y: auto;
    }
  }
  .issue-title{
    background: #fbfbfc;
    border: 1px solid #ecedee;
    padding: 16px;
    margin-bottom: 10px;
    h1{
      font-weight: normal;
      line-height: 30px;
    }
    p{
      margin-top: 6px;
      line-height: 20px;
    }
  }
  .hint{
    margin-bottom: 10px;
  }
  .confirm{
    border-bottom: 1px solid #ecedee;
    .confirm-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      height: 73px;
      border-left: 1px solid #ecedee;
      border-right: 1px solid #ecedee;
      border-top: 1px solid #ecedee;
      .left{
        p{
          display: flex;
          justify-content: center;
          align-items: center;
          .step{
            margin-left: 20px;
            border-right: 1px solid #ecedee;
            font-size: 20px;
            color: #555;
            width: 90px;
            display: block;
          }
          .step-info{
            font-size: 14px;
            line-height: 20px;
            color: #666;
            font-weight: 400;
            width: 458px;
            margin-left: 16px;
            word-break: break-word
          }
        }

      }
      .right{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 10%;
        span{
          color: black;
          display: block;
          font-size: 14px;
          width: 80%;
          margin-right: 6px;
          word-break: break-word;
        }
        i{
          color: rgb(198, 203, 209);
          line-height: 72px;
          margin-right: 16px;
          font-size: 14px;
        }
        .span-active{
          color: #888;
        }
        .i-active{
          color: rgb(0, 112, 204);
        }
      }
    }
  }
</style>
